import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, inject, output } from '@angular/core';
import {Chat, ChatParticipante} from '@cdk/models';
import { MatToolbar, MatIcon, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem } from '@cdk/angular/material';

import { ChatImagemComponent } from '../chat-imagem/chat-imagem.component';

@Component({
    selector: 'chat-mensagem-header',
    templateUrl: './chat-mensagem-header.component.html',
    styleUrls: ['./chat-mensagem-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
        imports: [MatToolbar, MatIcon, ChatImagemComponent, MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class ChatMensagemHeaderComponent implements OnInit, OnChanges
{
    private _changeDetectorRef = inject(ChangeDetectorRef);

    @Input()
    chat: Chat = null;

    readonly fecharChatHandler = output<void>();

    readonly chatFormHandler = output<Chat>();

    readonly excluirChatHandler = output<Chat>();

    readonly chatParticipantesHandler = output<Chat>();

    readonly sairChatHandler = output<ChatParticipante>();



    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
    }

    fecharChat() : void
    {
        this.fecharChatHandler.emit();
    }

    chatForm(): void
    {
        this.chatFormHandler.emit(this.chat);
    }

    chatParticipantes(): void
    {
        this.chatParticipantesHandler.emit(this.chat);
    }

    sairChat(): void
    {
        this.sairChatHandler.emit(this.chat.chatParticipante);
    }

    excluirChat(): void
    {
        this.excluirChatHandler.emit(this.chat);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        this._changeDetectorRef.markForCheck();
    }

}
